
import ParticleEffectEntity, { ParticleEffectEntityOptions } from "./ParticleEffectEntity"
import Vector from "../../Vector"

export type DamageParticleEffectOptions = { variant?: undefined | "dead" } & ParticleEffectEntityOptions

export default class DamageParticleEffect extends ParticleEffectEntity {


	constructor(options: DamageParticleEffectOptions) {
		super(options)

		const addVelocity = new Vector(40, 0).rotateToDeg(Math.random() * 360)

		this.velocity.add(addVelocity)
	}

}